(function ($) {
    $(document).ready(() => {

        // Support awesome-checkboxes
        // See https://codepen.io/andreasstorm/pen/deRvMy
        let unique_checkbox_id = 0;
        $(".awesome-checkbox").each((i, container) => {

            let $label = $(container)
                    .removeClass('awesome-checkbox')
                    .find('label')
                    // WPForm also uses labels, exclude them!
                    .not('.wpforms-label-hide')
                    .not('.wpforms-error')
                    .prepend(
                        $('<svg width="18px" height="18px" viewBox="0 0 18 18">' +
                            '<path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>' +
                            '<polyline points="1 9 7 14 15 4"></polyline>' +
                            '</svg>')),
                $container = $label.parent()
                    .addClass('awesome-checkbox'),
                $checkbox = $container
                    .find('input[type=checkbox]')
                    .css('visibility', 'hidden')
                    .css('position', 'absolute');

            // Fix wpcf7 checkboxes that are placed in the label
            if ($checkbox.closest('.wpcf7-form').length > 0)
                $checkbox.insertBefore($label);

            // Give checkbox an "id" and assign it to the label
            let id = $checkbox.prop('id');
            if (!id) {
                id = `awe-cbx-${unique_checkbox_id++}`;
                $checkbox.prop('id', id);
                $label.prop('for', id);
            }
        });
    });

}(jQuery));